module.exports = __webpack_public_path__ + "static/media/et.577c0d66.svg";